// extracted by mini-css-extract-plugin
export default {"modifiers":"MMBN-Modifiers_modifiers__tgTm7"};